import React from 'react';
import { getTranslations } from '../../../services/languageUtils';
import CryptoDeposit from '../../Modals/CryptoDeposit';
import { ToastContainer, toast } from 'react-toastify';
import CryptoWithdrawal from '../../Modals/CryptoWithdrawal';
import AccountManagerService from '../../../services/Celcoin/accountManagerService';
import CryptoTrade from '../../Modals/CryptoTrade';
import SuccessTransaction from '../../Modals/SuccessTransaction';
import criptoService from  '../../../services/Cripto/criptoFoxbitService';
import criptoUrbanService from  '../../../services/Cripto/criptoUrbanService';
import utilService from  '../../../services/Celcoin/utilService';
import UtilService from '../../../services/Celcoin/utilService';
import { switchCripto } from '../../../utils/switchCripto';
import { isBinance } from  '../../../utils/isBinance';

class CryptoTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: {},
      prices: {
        USDT: 5.20,
      },
      mockList: [{}],
      showDepositModal: false,
      showWithdrawalModal: false,
      showTradeModal: false,
      showSuccessTransactionModal: false,
      successModalData: {},
      address: "",
      network: "",
      coin: "",
      availableBalance: "",
      currentBalance: "",
      balanceData: {},
      intervalId: null,
      show2FAModal: false,
      twoFactorCode: '',
      loading2FA: false,
      pendingTradeData: null,
    };

    this.openDepositModal = this.openDepositModal.bind(this);
    this.closeDepositModal = this.closeDepositModal.bind(this);
    this.openWithdrawalModal = this.openWithdrawalModal.bind(this);
    this.closeWithdrawalModal = this.closeWithdrawalModal.bind(this);
    this.openTradeModal = this.openTradeModal.bind(this);
    this.closeTradeModal = this.closeTradeModal.bind(this);
    this.closeSuccessTransactionModal = this.closeSuccessTransactionModal.bind(this);
    this.verify2FAForTrade = this.verify2FAForTrade.bind(this);
    this.cancel2FA = this.cancel2FA.bind(this);
    this.handleTwoFactorCodeChange = this.handleTwoFactorCodeChange.bind(this);
    this.handleEnter2FA = this.handleEnter2FA.bind(this);
  }

  componentDidMount() {
    this.loadTranslations();
    this.getBalance();

    this.createQuote();
    const that = this;
    const intervalId = setInterval(() => {
      that.createQuote();
    }, 30000);
    this.setState({intervalId: intervalId});
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getBalance() {
    const that = this;
    if(switchCripto() === "1"){
      AccountManagerService.showBalance().then((res) => {
        that.setState({
          availableBalance: res.data.body.amount.toString(),
          currentBalance: res.data.body.amount.toString(),
          balanceData: res.data.body
        });
      }).catch((err) => {
        console.error(err);
      });
    } else {
      criptoUrbanService.showBalance().then((res) => {
        that.setState({
          availableBalance: res.data[0] ? res.data[0].balance : "0",
          currentBalance: res.data[0] ? res.data[0].balance : "0",
          balanceData: res.data
        });
      }).catch((err) => {
        console.error(err);
        that.setState({
          availableBalance: "0",
          currentBalance: "0"
        });
      });
    }
  }

  async loadTranslations() {
    const translations = await getTranslations(localStorage.getItem('language') || 'pt');
    this.setState({ translations });
  }

  createQuote() {
    const that = this;
    if(switchCripto() === "1"){
      let data = {
        service: "2",
        body: {
          fromCurrency: "USDT",
          toCurrency: "BRL",
          side: "Compra",
          receiveAmount: "1",
          spendAmount: "",
          email: sessionStorage.getItem('emailUser')
        }
      };

      if(!isBinance()){
        criptoService.createQuote(data).then((res) => {
          that.setState({
            prices: {
              USDT: Number(res.data.price),
            }}
          );
        }).catch((err) => {
          console.error(err);
        });
      }
      else {
        data = {
          body: {
            base_currency: "USDT",
            quote_currency: "BRL",
            side: "buy",
            quantity: "1",
            email: sessionStorage.getItem('emailUser')
          }
        };
        criptoService.createQuoteBnb(data).then((res) => {
          that.setState({
            prices: {
              USDT: Number(res.data.price),
            }}
          );
        }).catch((err) => {
          console.error(err);
        });
      }
    }
    else {
      const data = {
        fromAsset: "USDT",
        toAsset: "BRL",
        fromAmount: "100",
        settlement: "D0D0"
      };;

      criptoUrbanService.createQuote(data).then((res) => {
        that.setState({
          prices: {
            USDT: Number(res.data.ratio.replace(",",".")),
          }}
        );
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  openDepositModal(asset) {
    const that = this;

    if(switchCripto() === "1"){
      criptoService.showWalletAddress({
        service: "2",
        currencySymbol: "USDT",
        network: "erc20"
      }).then((res) => {
        that.setState({ 
          showDepositModal: true,
          address: res.data.address, 
          network: res.data.network.name, 
          coin: res.data.currency_symbol,
        });
      }).catch((err) => {
        console.error(err);
      });
    }
    else {
      criptoUrbanService.showWalletAddress({
        coin: "USDT",
        network: "TRX"
      }).then((res) => {
        console.log(res);
        that.setState({ 
          showDepositModal: true,
          address: res.data[0].address, 
          network: "TRX", 
          coin: "USDT",
        });
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  closeDepositModal() {
    this.setState({ showDepositModal: false });
  }

  openSuccessTransactionModal() {
    this.setState({ 
      showSuccessTransactionModal: true
    });
  }

  closeSuccessTransactionModal() {
    this.setState({ showSuccessTransactionModal: false });
  }

  toastMessage(type, message) {
      switch(type){
        case 'success':
          return toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "success",
            theme: "light"
          });
        default:
          return toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
            theme: "light"
          });
      }
  }

  openWithdrawalModal(asset) {
    this.setState({ 
      showWithdrawalModal: true,
      selectedAsset: asset,
    });
  }

  async closeWithdrawalModal(data) {
    const that = this;
    this.setState({ showWithdrawalModal: false });

    if(data === null)
      return;

    try {
      await utilService.validateAuth(sessionStorage.getItem('emailUser').toString(), data.password);

      if(switchCripto() === "1"){
        criptoService.createWithdrawal({
          service: "2",
          body: {
            amount: data.value,
            currency_symbol: data.coin,
            network_code: data.network,
            destination_address: data.address,
            destination_tag: ""
          }
        }).then((res) => {
          that.setState({ 
            showDepositModal: true,
            address: res.data.address, 
            network: res.data.network.name, 
            coin: res.data.currency_symbol,
            successModalData: res.data }, () => {
            that.openSuccessTransactionModal();
          });
          that.getBalance();
        }).catch((err) => {
          that.getBalance();
          console.error(err);
          return that.toastMessage('error', 'Erro no saque. Verifique os dados');
        });
      } else {
        criptoUrbanService.createWithdrawal({
          addressID: "408",
          amount: data.value + ""
        }).then((res) => {
          that.setState({ 
            showDepositModal: true,
            address: res.data.address, 
            network: res.data.network.name, 
            coin: res.data.currency_symbol,
            successModalData: res.data }, () => {
            that.openSuccessTransactionModal();
          });
          that.getBalance();
        }).catch((err) => {
          that.getBalance();
          console.error(err);
          return that.toastMessage('error', 'Erro no saque. Verifique os dados');
        });
      }
    } catch (error) {
      return that.toastMessage('error', that.state.translations.loginFailed);
    }
  }

  openTradeModal(asset) {
    this.setState({ 
      showTradeModal: true,
      selectedAsset: asset,
    });
  }

  async closeTradeModal(data) {
    this.setState({ showTradeModal: false });

    if(data === null)
      return;
    
    this.setState({
      pendingTradeData: data,
      show2FAModal: true,
      twoFactorCode: ''
    });
  }

  verify2FAForTrade = async () => {
    if (this.state.twoFactorCode.length !== 6) {
      return this.toastMessage('error', this.state.translations.invalidCode || 'Código deve ter 6 dígitos');
    }

    this.setState({ loading2FA: true });

    try {
      await UtilService.verify2FAForTransaction(
        sessionStorage.getItem("emailUser"), 
        this.state.twoFactorCode
      );
      
      this.setState({ 
        show2FAModal: false, 
        loading2FA: false,
        twoFactorCode: '' 
      });
      
      this.executeTrade();
      
    } catch (error) {
      this.setState({ loading2FA: false });
      this.toastMessage('error', this.state.translations.invalid2FACode || 'Código 2FA inválido');
    }
  }

  cancel2FA = () => {
    this.setState({
      show2FAModal: false,
      twoFactorCode: '',
      loading2FA: false,
      pendingTradeData: null
    });
  }

  handleTwoFactorCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').substring(0, 6);
    this.setState({ twoFactorCode: value });
  }

  handleEnter2FA = (e) => {
    if (e.key === 'Enter' && this.state.twoFactorCode.length === 6) {
      this.verify2FAForTrade();
    }
  }

  executeTrade = async () => {
    const that = this;
    const data = this.state.pendingTradeData;
    
    if (!data) return;
    
    try {
      if(switchCripto() === "1"){
        const body = {
          amountCrypto: data.value,
          amountFiat: data.amountFiat,
          marketSymbol: data.coin,
          networkCode: data.network,
          destinationAddress: data.address,
          destinationTag: "Saque Cripto",
          email: sessionStorage.getItem('emailUser').toString(),
          side: "BUY",
          type: "MARKET",
          currencySymbol: "USDT"
        };
        
        if(!isBinance()){
          criptoService.executeTrade(body).then((res) => {
            that.setState({
              successModalData: res.data,
              pendingTradeData: null
            }, () => {
              that.openSuccessTransactionModal();
            });
            that.getBalance();
          }).catch((err) => {
            that.getBalance();
            that.setState({ pendingTradeData: null });
            console.error(err);
            return that.toastMessage('error', 'Erro na compra. Verifique os dados');
          });
        }
        else {
          criptoService.executeTradeBnb(body).then((res) => {
            that.setState({
              successModalData: res.data,
              pendingTradeData: null
            }, () => {
              that.openSuccessTransactionModal();
            });
            that.getBalance();
          }).catch((err) => {
            that.getBalance();
            that.setState({ pendingTradeData: null });
            console.error(err);
            return that.toastMessage('error', 'Erro na compra. Verifique os dados');
          });
        }
      } else {
        const req = {
          fromAsset: data.tradeType === "BUY" ? "USDT":"BRL",
          toAsset: data.tradeType === "BUY" ? "BRL":"USDT",
          fromAmount: `${data.value}`,
          settlement: "D0D0"
        };

        criptoUrbanService.createQuote(req).then((res) => {
          criptoUrbanService.executeQuote({
            quoteId: res.data.quoteId
          }).then((res) => {
            console.log(res);
            that.setState({
              successModalData: res.data,
              pendingTradeData: null
            }, () => {
              that.openSuccessTransactionModal();
            });
            that.getBalance();
          }).catch((err) => {
            that.getBalance();
            that.setState({ pendingTradeData: null });
            console.error(err);
            return that.toastMessage('error', 'Erro na compra. Verifique os dados');
          });
        }).catch((err) => {
          that.setState({ pendingTradeData: null });
          console.error(err);
          return that.toastMessage('error', 'Erro na compra. Verifique os dados');
        });
      }
    }
    catch (error) {
      that.setState({ pendingTradeData: null });
      return that.toastMessage('error', 'Erro na compra. Verifique os dados');
    }
  }

  render() {
    const list = this.props.list && this.props.list.length > 0 ? this.props.list : this.state.mockList;

    return (
      <section className="TableContent" id="ComponentTable">
        <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 8px' }}>
            <thead>
              <tr>
                <th style={{ borderRadius: '8px 0 0 8px', padding: '16px', textAlign: 'left' }}>
                  {this.state.translations.assets || 'Assets'}
                </th>
                <th style={{ padding: '16px', textAlign: 'center' }}>
                  {this.state.translations.price || 'Price'}
                </th>
                <th style={{ borderRadius: '0 8px 8px 0', padding: '16px' }}></th>
              </tr>
            </thead>

            <tbody>
              {list.map((item, index) => {
                const assetName = 'USDT';
                const price = this.state.prices.USDT;

                return (
                  <tr key={index} style={{ height: '60px' }}>
                    <td
                      style={{
                        borderRadius: '8px 0 0 8px',
                        backgroundColor: '#f5f5f5',
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        height: '60px',
                      }}
                    >
                      <img 
                        src={require('../../../assets/imgs/usdt.png')} 
                        alt="USDT Logo" 
                        style={{ width: 24, height: 24 }} 
                      />
                      <span>{assetName}</span>
                    </td>

                    <td
                      style={{
                        backgroundColor: '#f5f5f5',
                        padding: '16px',
                        textAlign: 'center',
                        height: '60px',
                      }}
                    >
                      {price}
                    </td>

                    <td
                      style={{
                        borderRadius: '0 8px 8px 0',
                        backgroundColor: '#f5f5f5',
                        padding: '16px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: 8,
                        height: '60px',
                      }}
                    >
                      {
                        // <button
                        //   style={{
                        //     backgroundColor: '#1c787e',
                        //     color: 'white',
                        //     border: 'none',
                        //     borderRadius: 8,
                        //     padding: '6px 12px',
                        //     cursor: 'pointer',
                        //   }}
                        //   onClick={() => this.openDepositModal(assetName)}
                        // >
                        //   {this.state.translations.deposit || 'Deposit'}
                        // </button>
                      
                      // <button
                      //   style={{
                      //     backgroundColor: '#1c787e',
                      //     color: 'white',
                      //     border: 'none',
                      //     borderRadius: 8,
                      //     padding: '6px 12px',
                      //     cursor: 'pointer',
                      //   }}
                      //   onClick={() => this.openWithdrawalModal(assetName)}
                      // >
                      //   {this.state.translations.withdraw || 'Withdraw'}
                      // </button>
                      }
                      <button
                        style={{
                          backgroundColor: '#1c787e',
                          color: 'white',
                          border: 'none',
                          borderRadius: 8,
                          padding: '6px 12px',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.openTradeModal(assetName)}
                      >
                        {this.state.translations.buy || 'Buy'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Modales */}
        {this.state.showDepositModal && (
          <CryptoDeposit 
            onClose={this.closeDepositModal}
            coin={this.state.coin}
            network={this.state.network}
            address={this.state.address}
          />
        )}

        {this.state.showWithdrawalModal && (
          <CryptoWithdrawal 
            onClose={this.closeWithdrawalModal}
            asset={this.state.selectedAsset}
            balanceData={this.state.balanceData}
          />
        )}

        {this.state.showTradeModal && (
          <CryptoTrade 
            onClose={this.closeTradeModal}
            availableBalance={this.state.availableBalance}
            currentBalance={this.state.currentBalance}
            price={this.state.prices.USDT}
            amount={"0"}
          />
        )}

        {this.state.showSuccessTransactionModal && (
          <SuccessTransaction 
            onClose={this.closeSuccessTransactionModal}
            data={this.state.successModalData}
          />
        )}

        {this.state.show2FAModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "24px",
                minWidth: "350px",
                maxWidth: "90%",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
                {this.state.translations.twoFactorAuthentication || 'Autenticação de Dois Fatores'}
              </h3>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                {this.state.translations.enterCodeFromApp || 'Digite o código de 6 dígitos do seu aplicativo autenticador:'}
              </p>
              
              <input
                type="text"
                value={this.state.twoFactorCode}
                onChange={this.handleTwoFactorCodeChange}
                onKeyDown={this.handleEnter2FA}
                maxLength="6"
                placeholder="000000"
                disabled={this.state.loading2FA}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "18px",
                  textAlign: "center",
                  letterSpacing: "4px",
                  border: "2px solid #ddd",
                  borderRadius: "6px",
                  margin: "16px 0",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              
              <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "20px" }}>
                <button 
                  onClick={this.cancel2FA}
                  disabled={this.state.loading2FA}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #aaa",
                    color: "#555",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA ? "not-allowed" : "pointer",
                    opacity: this.state.loading2FA ? 0.6 : 1,
                  }}
                >
                  {this.state.translations.cancel || 'Cancelar'}
                </button>
                <button 
                  onClick={this.verify2FAForTrade}
                  disabled={this.state.loading2FA || this.state.twoFactorCode.length !== 6}
                  style={{
                    backgroundColor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "#ccc" : "#1c787e",
                    border: "none",
                    color: "white",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "not-allowed" : "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.loading2FA ? (this.state.translations.verifying || 'Verificando...') : (this.state.translations.verify || 'Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </section>
    );
  }
}

export default CryptoTable;
